import { render } from "./ChangeLanguage.vue?vue&type=template&id=54bfce0c&ts=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=ts"
export * from "./ChangeLanguage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__